import { i18n } from '@/plugins/vueI18n'

export const useI18n = () => {
  const t = (key: string, ...args: unknown[]) => {
    return i18n?.global.t(key, ...args) || key
  }

  return {
    t
  }
}